


















import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer.vue"
import TimeslotSelector from "@/components/TimeslotSelector.vue";

@Component({
  components: {
    CardContainer,
    TimeslotSelector
  }
})

export default class TimeSlotSelect extends Vue {
  @Prop({ required: true }) readonly merchant!: MerchantStore
  @Prop({ required: false, default: false }) readonly nocontainer!: Boolean
  @Prop() readonly timeslot!: null | TimeSlot
  
  isOpen = false
  loading = true
  slots: Array<TimeSlot> = []
  selectedSlot: null|TimeSlot = null
  
  open () {
    this.isOpen = true
  }

  close () {
    this.isOpen = false
  }

  @Emit('select')
  onSelect (select: TimeSlot) {
    this.selectedSlot = select
    this.close()
    return this.selectedSlot
  }

  get slotTime () {
    if (!this.selectedSlot) return this.loading ? 'label.loading' : 'label.available.slot'
    if (this.selectedSlot.pickupNow) return this.$t('label.pickup-now')
    return `${this.selectedSlot.startTime} - ${this.selectedSlot.endTime}`
  }

  async fetch () {
    this.loading = true
    const slots = await this.$tinabaAPI.$vas.getAvailableSlots(this.merchant.businessId, this.merchant.shopId, this.merchant.id)
    this.slots = slots

    if (this.slots.length) {
      const existingTimeslot = this.selectedSlot ? this.slots.find(slot => slot.endDate === this.selectedSlot?.endDate && slot.startTime === this.selectedSlot?.startTime) : null
      if (existingTimeslot) {
        this.selectedSlot = existingTimeslot
      } else {
        this.onSelect(this.slots[0])
      }
    } else {
      this.selectedSlot = null
    }
    this.loading = false
  }

  created () {
    if (this.timeslot) {
      this.selectedSlot = this.timeslot
    }
    this.fetch()
  }

  @Watch('merchant.id')
  handleMerchantChange () {
    this.selectedSlot = null
    this.slots = []
    this.fetch()
  }
}
